

export const tableData = {
  tHead: [
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '管理员姓名',
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '管理员手机',
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '专家管理',
      
      width: 100,
      slot: 'operate1',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '重置密码',
      
      width: 100,
      slot: 'operate',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};

export const authManageRoleListNewData = [
  {
    id: 'baseInfo',
    title: '',
    data: [
      {
        id: 'uid',
        name: '请输入新密码',
        placeholder: '',
        type: 'input',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'uid'
      },
      {
        id: 'name',
        name: '再次输入新密码',
        placeholder: '',
        type: 'input',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'name'
      },
    ]
  }]
